import { render, staticRenderFns } from "./DetailThree.vue?vue&type=template&id=c8726e72&"
import script from "./DetailThree.vue?vue&type=script&lang=js&"
export * from "./DetailThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8726e72')) {
      api.createRecord('c8726e72', component.options)
    } else {
      api.reload('c8726e72', component.options)
    }
    module.hot.accept("./DetailThree.vue?vue&type=template&id=c8726e72&", function () {
      api.rerender('c8726e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/details/DetailThree.vue"
export default component.exports